import Api from "~/utils/Api"
import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { ApiUser } from "~/types"

export const useUsers = () =>
  useQuery({
    placeholderData: keepPreviousData,
    queryKey: ["users"],
    queryFn: () =>
      Api.get("users").then((response) => response.data["data"] as ApiUser[]),
  })
